import React from 'react';
import { useHover } from "../../context/HoverContext";
import './FakeLink.css';

const FakeLink = ({ children, url, onClick, style }) => {
  const { setHoveredUrl } = useHover();

  return (
    <button
      className="fake-link"
      style={style}
      onMouseOver={() => setHoveredUrl(url)}
      onMouseOut={() => setHoveredUrl('')}
      onFocus={() => setHoveredUrl(url)}
      onBlur={() => setHoveredUrl('')}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default FakeLink;